import React from 'react';
import MUITabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

import { useStyles } from './styles';

export interface TabsItem {
  label: string;
  value: string | number | boolean;
}

type TabsProps<T> = {
  value: TabsItem['value'];
  tabs: TabsItem[];
  onChange: (e: React.ChangeEvent<Record<string, string>>, value: T) => void;
  activeTabColor?: string;
};

export const Tabs = <T extends string>({ value, tabs, onChange, activeTabColor }: TabsProps<T>) => {
  const classes = useStyles({ activeTabColor });

  return (
    <MUITabs
      value={value}
      onChange={onChange}
      indicatorColor="primary"
      textColor="primary"
      centered
      classes={{ flexContainer: classes.tabsContainer, indicator: classes.tabsIndicator }}
    >
      {tabs?.map((tab, index) => (
        <Tab
          key={`tab-${tab.value}-${index}`}
          value={tab.value}
          label={tab.label}
          classes={{ root: classes.tabRoot }}
        />
      ))}
    </MUITabs>
  );
};
